module.exports = __webpack_public_path__ + "img/img-avatar13.cfbc2a83.jpg";